<template>
  <div class="page-list">
    <div class="page-title">
      <div class="page-back" @click="$router.go(-1)">
        <svg style="width:24px;height:24px" viewBox="0 0 24 24">
          <path fill="currentColor" d="M10.05 16.94V12.94H18.97L19 10.93H10.05V6.94L5.05 11.94Z" />
        </svg>
      </div>
      История
    </div>

    <div class="page-subtitle">
      Полученные СПАСИБО
      <div style="font-size: 32px; padding-top: 12px; color: dodgerblue">{{toCount }}</div>
    </div>

    <div class="stats">
      <div class="card" v-for="(it, index) in to" :key="index" style="width: 100%; border-left: 5px solid black; border-right: 5px solid black; position: relative; overflow: hidden" :style="{'border-left-color': getWorthColor(it.worth), 'border-right-color': getWorthColor(it.worth)}">
        <div class="card-subtitle" style="margin: 0; padding: 0 0 4px;; font-family: sans; font-size: 12px; color: #16a085"> {{ getWorth(it.worth).name }} </div>
        <div class="card-title" style="font-family: serif; font-size: 18px; color: #2c3e50"> {{ getName(it.from) }} </div>
        <div class="card-subtitle" style="color: #3498db; font-size: 10px;"> <b> {{ it.count }} СПАСИБО </b> <i> {{ new Date(it.date).toLocaleDateString() }} </i> </div>
        <div class="card-subtitle"> <i> {{ it.comment }} </i> </div>
        <div class="icon" v-html="getIcon(it.worth)"></div>
        <div class="icon-large" v-html="getIcon(it.worth)"></div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'HistoryPage',
  computed: {
    from() {
      const res = this.$store.getters.from
      res.sort((b, a) => new Date(a.date).getTime() - new Date(b.date).getTime())
      return res
    },
    to() {
      const res = this.$store.getters.to
      res.sort((b, a) => new Date(a.date).getTime() - new Date(b.date).getTime())
      return res
    },
    toCount() {
      return this.$store.getters.toCount
    },
    employee() {
      return this.$store.getters.employee
    },
    values() {
      return this.$store.getters.values
    }
  },
  methods: {
    getIcon(worth) {
      if (worth === 998) return this.getOwnWorth().icon
      if (worth === 999) return this.getOwnWorth().icon
      const item = this.values.find(it => it.id === worth)
      return item ? item.icon : ''
    },
    getName(employeeId) {
      const employee = this.employee.find(it => it.id === employeeId)
      return employee ? employee.name : ''
    },
    getWorth(worth) {
      if (worth === 999) return {
        id: 999,
        name: 'Общая',
        description: 'Заработанные СПАСИБО',
        conditions: [ ],
        icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><title>account-school</title><path fill="currentColor" d="M16 8C16 10.21 14.21 12 12 12C9.79 12 8 10.21 8 8L8.11 7.06L5 5.5L12 2L19 5.5V10.5H18V6L15.89 7.06L16 8M12 14C16.42 14 20 15.79 20 18V20H4V18C4 15.79 7.58 14 12 14Z" /></svg>',
        color: 'gray'
      }
      if (worth === 998) return {
        id: 998,
        name: 'Общая',
        description: 'Заработанные СПАСИБО',
        conditions: [ ],
        icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><title>account-school</title><path fill="currentColor" d="M16 8C16 10.21 14.21 12 12 12C9.79 12 8 10.21 8 8L8.11 7.06L5 5.5L12 2L19 5.5V10.5H18V6L15.89 7.06L16 8M12 14C16.42 14 20 15.79 20 18V20H4V18C4 15.79 7.58 14 12 14Z" /></svg>',
        color: 'gray'
      }
      return this.values.filter(it => it.id === worth)[0]
    },
    getOwnWorth() {
      return {
        id: 999,
        name: 'Общая',
        description: 'Заработанные СПАСИБО',
        conditions: [ ],
        icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><title>account-school</title><path fill="currentColor" d="M16 8C16 10.21 14.21 12 12 12C9.79 12 8 10.21 8 8L8.11 7.06L5 5.5L12 2L19 5.5V10.5H18V6L15.89 7.06L16 8M12 14C16.42 14 20 15.79 20 18V20H4V18C4 15.79 7.58 14 12 14Z" /></svg>',
        color: 'gray'
      }
    },
    getWorthColor(worth) {
      console.log(worth)
      if (worth === 999) return 'blue'
      return this.values.filter(it => it.id === worth)[0].color
    }
  }
}
</script>

<style scoped>
.page-subtitle {
  margin-top: 32px;
  margin-bottom: 8px;
  padding-bottom: 0;
}
.stat-item {
  padding: 8px 18px;
  font-weight: 400;
  display: flex;
  font-size: 16px;
}
.amount {
  margin-right: 0;
  margin-left: auto;
  font-weight: 500;
}
.stat-item large {
  font-size: 20px;
}
.icon {
  position: absolute;
  top: 12px;
  right: 16px;
  color: #8e44ad;
  width: 24px;
  height: 24px;
}
.icon-large {
  position: absolute;
  top: 12px;
  right: 16px;
  color: #8e44ad11;
  transform: scale(3) translate(-35%, 35%);
  width: 24px;
  height: 24px;
  opacity: 0.1;
}
</style>
